import { render } from "./wordDetailTable.vue?vue&type=template&id=1a501092&scoped=true"
import script from "./wordDetailTable.vue?vue&type=script&lang=js"
export * from "./wordDetailTable.vue?vue&type=script&lang=js"

import "./wordDetailTable.vue?vue&type=style&index=0&id=1a501092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a501092"]])

export default __exports__